module.exports = __webpack_public_path__ + "static/media/3DPPA42.b9bac27f.jpg";